<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
                    <el-form-item label="用户">
        <!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                        <GridSelect
                            style='width: 177px'
                            title='选择用户'
                            labelName='userName'
                            labelValue='id'
                            :value='queryForm.userId'
                            :limit='1'
                            size='small'
                            placeholder='请选择用户'
                            @getValue='(value) => {queryForm.userId = value}'
                            :columns="USER_code"
                            :searchs="USER_search"
                            dataListUrl='/mpp/user/findList'
                            entityBeanName='mppUser'
                            queryEntityUrl='/mpp/user/get'
                        >
                        </GridSelect>
                    </el-form-item>
                    <el-form-item label="组织类型">
        <!--                  <el-input  v-model="queryForm.orgType"></el-input>-->
                        <el-select style='width: 177px;' v-model="queryForm.orgType" placeholder="请选择" clearable size="small">
                            <el-option :value="1" label="店铺">
                            </el-option>
                            <el-option :value="2" label="门店">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="组织" v-if="queryForm.orgType">
        <!--                  <el-input style='width: 177px' v-model="queryForm.orgId"></el-input>-->
                        <GridSelectU
                            style="width: 177px"
                            v-if="queryForm.orgType == 2"
                            title="选择门店"
                            labelName="storeName"
                            labelValue="id"
                            :value="queryForm.orgId"
                            :limit="1"
                            size="small"
                            placeholder="请选择门店"
                            @getValue="(value) => {queryForm.orgId = value}"
                            :columns="STORE_code"
                            :searchs="STORE_search"
                            dataListUrl="/shop/store/findList"
                            entityBeanName="shopStore"
                            queryEntityUrl="/shop/store/get"
                        >
                        </GridSelectU>

                        <GridSelectU
                            v-if="queryForm.orgType == 1"
                            style="width: 177px"
                            title="选择店铺"
                            labelName="shopName"
                            labelValue="id"
                            :value="queryForm.orgId"
                            :limit="1"
                            size="small"
                            placeholder="请选择店铺"
                            @getValue="(value) => {queryForm.orgId = value}"
                            :columns="SHOP_code"
                            :searchs="SHOP_search"
                            dataListUrl="/mall/shop/findList"
                            entityBeanName="mallShop"
                            queryEntityUrl="/mall/shop/get"
                        >
                        </GridSelectU>
                    </el-form-item>
                    <el-form-item label="来源" >
                        <el-select style='width: 177px;' v-model="queryForm.isHand" placeholder="请选择" clearable size="small">
                            <el-option value="1" label="手动">
                            </el-option>
                            <el-option value="2" label="自动">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否结束">
        <!--                  <el-input  v-model="queryForm.isOver"></el-input>-->
                        <el-select style='width: 177px;' v-model="queryForm.isOver" placeholder="请选择" clearable size="small">
                            <el-option :value="1" label="是">
                            </el-option>
                            <el-option :value="0" label="否">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker
                            style="width: 200px"
                            v-model="timeRange"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopIncomeVoucherList">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
                    </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-plus"
                    @click="addShopIncomeVoucher"
                    >新建</el-button>
                    <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-plus"
                    @click="auditListclick"
                    >审核</el-button>
                    <span class="count">
                        消费凭证:
                        {{ formatNumber(countObj.money1Count) }}
                    </span>
                    <span class="count">
                        贡献值:
                        {{ formatNumber(countObj.money2Count) }}
                    </span>
                    <span class="count">
                        消费券额度:
                        {{ formatNumber(countObj.money3Count) }}
                    </span>
                    <span class="count">
                        动券宝额度:
                        {{ formatNumber(countObj.money4Count) }}
                    </span>
                    <span class="count">
                        累计释放:
                        {{ formatNumber(countObj.totalMoneyCount) }}
                    </span>
                </div>
                <div>点击查询展示数据</div>
            <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                    class="upload-demo"
                    action="#"
                                    :http-request="upload"
                    :show-file-list="true">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                <span
                title="搜索"
                class="icon-box"
                @click="search"
                >
                <Icon color="#606266">
                    <Search />
                </Icon>
                </span>
        <!--        <span-->
        <!--          title="下载模板"-->
        <!--          class="icon-box"-->
        <!--          @click="importTemplate"-->
        <!--        >-->
        <!--          <Icon color="#606266">-->
        <!--            <ArrowDown />-->
        <!--          </Icon>-->
        <!--        </span>-->
        <!--        <span-->
        <!--          class="icon-box"-->
        <!--          title="导入数据"-->
        <!--          @click="isImport"-->
        <!--        >-->
        <!--          <Icon color="#606266">-->
        <!--            <ArrowExportUp24Regular />-->
        <!--          </Icon>-->
        <!--        </span>-->
        <!--        <span-->
        <!--          title="导出数据"-->
        <!--          class="icon-box"-->
        <!--          @click="exportShopIncomeVoucherList"-->
        <!--        >-->
        <!--          <Icon color="#606266">-->
        <!--            <ArrowDownload24Regular />-->
        <!--          </Icon>-->
        <!--        </span>-->
                <span
                class="icon-box"
                @click="refreshShopIncomeVoucherList"
                >
                <Icon color="#606266">
                    <Refresh />
                </Icon>
                </span>
            </div>
            </div>
            <!-- 列表数据 -->
            <el-table
            :data="shopIncomeVoucherList"
            row-key="id"
            border
            height="100%"
            :header-row-style="{height: '10px'}"
            :header-cell-style="{padding: '10px'}"
            :row-style="{height: '9px'}"
            :cell-style="{padding: '9px'}"
            @selection-change="handleSelectionChange"
            size="small"
            v-loading="loading"
            >
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="userId"
                label="用户"
                min-width="140"
            >
                <template slot-scope='scope'>
                    <div v-if="scope.row.user">
                        <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                        <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                        <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                        <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                    </div>
                    <div v-else>--</div>
                </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="userId"
                label="审核信息"
                min-width="200"
            >
                <template slot-scope='scope'>
                    <div v-if="scope.row.shopSimulated">
                        <div style="text-align: left">创建人名称：{{ scope.row.shopSimulated.createUserName }}</div>
                        <div style="text-align: left">审核人名称：{{ scope.row.shopSimulated.userName }}</div>
                        <div style="text-align: left">审核时间：{{ scope.row.shopSimulated.auditTime }}</div>
                        <div style="text-align: left">创建时间：{{ scope.row.shopSimulated.createTime }}</div>
                        <div style="text-align: left">是否发放：{{ scope.row.shopSimulated.isSend == 1 ? '是' : '否' }}</div>
                    </div>
                    <div v-else>--</div>
                </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="orgType"
                label="组织类型"
                min-width="90"
            >
                <template slot-scope='scope'>
                    {{ scope.row.orgType == 1 ? '店铺' : (scope.row.orgType == 2 ? '门店' : '--') }}
                </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="false"
                align="center"
                prop="orgId"
                label="组织名称"
                min-width="90"
            >
                <template slot-scope='scope'>
                    <div v-if="scope.row.shop && scope.row.orgType == 1">
                        <div style="text-align: left">{{ scope.row.shop.shopName ? scope.row.shop.shopName : '--' }}</div>
                    </div>
                    <div v-else-if="scope.row.store && scope.row.orgType == 2">
                        <div style="text-align: left">{{ scope.row.store.storeName ? scope.row.store.storeName : '--' }}</div>
                    </div>
                    <div v-else>--</div>
                </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="false"
                align="center"
                prop="orderId"
                label="订单"
                min-width="100"
            > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="money1"
                    label="消费凭证"
                    width="90"
                >
                <template slot-scope='scope'>
                {{  formatNumber(scope.row.money1) }}
                </template>
                </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="money2"
                label="贡献值"
                min-width="80"
            >
            <template slot-scope='scope'>
                {{  formatNumber(scope.row.money2) }}
                </template> 
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="money3"
                label="消费券额度"
                min-width="110"
            >
            <template slot-scope='scope'>
                {{  formatNumber(scope.row.money3) }}
                </template> 
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="money4"
                label="动券宝额度"
                min-width="110"
            > 
            <template slot-scope='scope'>
                {{  formatNumber(scope.row.money4) }}
                </template> 
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="firstRatio"
                label="第一期比例"
                min-width="110"
            > </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="periods"
                label="期数"
                min-width="70"
            > </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="lastMoney"
                label="最后一期补贴金额"
                min-width="140"
            > </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="totalMoney"
                label="共计补贴金额"
                min-width="140"
            > </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="sendStatus"
                label="执行状态"
                min-width="90"
            > </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="isOver"
                label="是否结束"
                min-width="90"
            >
                <template slot-scope='scope'>
                    <div v-if="scope.row.isOver == 1">是</div>
                    <div v-else>否</div>
                </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="createTime"
                label="创建时间"
                min-width="150"
            > </el-table-column>
            
            <el-table-column
                fixed="right"
                align="center"
                label="操作"
                width="200"
            >
                <template slot-scope="scop">
                <div class="operation">
                    <div @click="openRecordDialog(scop.row.id)">
                        <Icon size="16">
                            <Eye24Regular />
                        </Icon>
                        <span class="operation-label">查看记录</span>
                    </div>
        <!--            <div @click="checkShopIncomeVoucher(scop.row.id)">-->
        <!--              <Icon size="16">-->
        <!--                <Eye24Regular />-->
        <!--              </Icon>-->
        <!--              <span class="operation-label">查看</span>-->
        <!--            </div>-->
        <!--            <div @click="editShopIncomeVoucher(scop.row.id)">-->
        <!--              <Icon size="16">-->
        <!--                <Edit24Regular />-->
        <!--              </Icon>-->
        <!--              <span class="operation-label">修改</span>-->
        <!--            </div>-->
                    <div @click="deleteShopIncomeVoucher(scop.row.id)">
                    <Icon size="16" style="color: red">
                        <Delete24Regular />
                    </Icon>
                    <span class="operation-label" style="color: red">删除</span>
                    </div>
                </div>
                </template>
            </el-table-column>
            </el-table>
            <div class="pagination-box">
            <el-pagination
                @size-change="sizeChange"
                @current-change="currentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                background
                :pager-count="7"
            >
            </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopIncomeVoucherStates[shopIncomeVoucherState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
            <div>
                <el-form
                :model="shopIncomeVoucher"
                ref="shopIncomeVoucherForm"
                :rules="rules"
                label-width="120px"
                :inline="true"
                size="small"
                >
                <el-form-item
                    label="用户"
                    prop="userId"
                >
                    <GridSelect
                        :disabled="shopIncomeVoucherState == 'check'"
                        style='width: 177px'
                        title='选择用户'
                        labelName='userName'
                        labelValue='id'
                        :value='shopIncomeVoucher.userId'
                        :limit='1'
                        size='small'
                        placeholder='请选择用户'
                        @getValue='(value) => {shopIncomeVoucher.userId = value}'
                        :columns="USER_code"
                        :searchs="USER_search"
                        dataListUrl='/mpp/user/findList'
                        entityBeanName='mppUser'
                        queryEntityUrl='/mpp/user/get'
                        
                    >
                    </GridSelect>
                </el-form-item>
                <el-form-item
                    label="是否发放"
                    prop="isSend"
                >
                    <el-select style='width: 177px;' v-model="shopIncomeVoucher.isSend" :disabled="shopIncomeVoucherState == 'check'" placeholder="请选择" clearable size="small">
                        <el-option :value="1" label="是">
                        </el-option>
                        <el-option :value="0" label="否">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="组织类型"
                    prop="orgType"
                >
                    <el-select style='width: 177px;' v-model="shopIncomeVoucher.orgType" :disabled="shopIncomeVoucherState == 'check'" placeholder="请选择" clearable size="small">
                        <el-option :value="2" label="门店">
                        </el-option>
                        <el-option :value="1" label="店铺">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="组织"
                    prop="orgId"
                    v-if="shopIncomeVoucher.orgType"
                >
                    <GridSelectLi
                        v-if="shopIncomeVoucher.orgType == 2"
                        style="width: 177px"
                        title="选择门店"
                        labelName="storeName"
                        :disabled="shopIncomeVoucherState == 'check'"
                        labelValue="id"
                        :value="shopIncomeVoucher.orgId"
                        :limit="1"
                        size="small"
                        placeholder="请选择门店"
                        @getValue="(value) => {shopIncomeVoucher.orgId = value}"
                        :columns="STORE_code"
                        :searchs="STORE_search"
                        dataListUrl="/shop/store/queryList"
                        entityBeanName="shopStore"
                        queryEntityUrl="/shop/store/get"
                    >
                    </GridSelectLi>

                    <GridSelectU
                        v-if="shopIncomeVoucher.orgType == 1"
                        style="width: 177px"
                        title="选择店铺"
                        labelName="shopName"
                        :disabled="shopIncomeVoucherState == 'check'"
                        labelValue="id"
                        :value="shopIncomeVoucher.orgId"
                        :limit="1"
                        size="small"
                        placeholder="请选择店铺"
                        @getValue="(value) => {shopIncomeVoucher.orgId = value}"
                        :columns="SHOP_code"
                        :searchs="SHOP_search"
                        dataListUrl="/mall/shop/findList"
                        entityBeanName="mallShop"
                        queryEntityUrl="/mall/shop/get"
                    >
                    </GridSelectU>
                </el-form-item>
                <el-form-item
                    label="服务费类型"
                    prop="serviceRadio"
                >
                    <el-select style='width: 177px;' v-model="shopIncomeVoucher.serviceRadio" :disabled="shopIncomeVoucherState == 'check'" placeholder="请选择" clearable size="small">
                        <el-option v-for="(item,index) in serviveTypeList" :value="item.value" :label="item.value" :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="消费金额"
                    prop="money"
                >
                    <el-input
                        size="small"
                        style='width: 177px'
                        v-model="displayValue"
                        @input="handleInput"
                    ></el-input>
                </el-form-item>
                </el-form>
            </div>

            <div
                slot="footer"
                class="flex justify-end"
            >
                <el-button @click="closeDialog">关闭</el-button>
                <el-button
                type="primary"
                @click="submitForm"
                v-if="shopIncomeVoucherState != 'check'"
                >确定</el-button>
            </div>
            </el-dialog>
            <!--   补贴记录管理   -->
            <el-drawer
                title="补贴记录管理"
                :visible.sync="showRecordDialog"
                direction="rtl"
                size="70%"
                :before-close="closeRecordDialog">
                <ShopIncomeVoucherRecord ref="record"></ShopIncomeVoucherRecord>
            </el-drawer>
        </div>
        <!-- 审核列表 -->
        <el-dialog
            title="审核列表"
            :visible.sync="auditshow"
            @close="goodsCloseDialog"
            width="90%"
            height="80%"
        >
            <AuditList v-if="auditshow" ></AuditList>
        </el-dialog>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import { SHOP, SHOP_SEARCH, STORE, STORE_SEARCH, UPLOAD_API, UPLOAD_PATH } from '@/utils/constant';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import GridSelectU from '@/components/gridselect/index.vue';
import ShopIncomeVoucherRecord from '@/components/StoreManagement/ShopIncomeVoucherRecord.vue';
import AuditList from './common/auditList.vue';
export default {
    components: {
        ShopIncomeVoucherRecord,
        GridSelectU,
        GridSelectLi,
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        AuditList
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopIncomeVoucherList();
                    this.getShopIncomeVoucherList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopIncomeVoucherList();
                    this.getShopIncomeVoucherList();
                    this.$emit('resetCheckState');
                }
            },
            'shopIncomeVoucher.orgType'(id, oldId) {
                if(id == oldId){
                    return;
                }
                if (!this.getOrgType) {
                    this.shopIncomeVoucher.orgId = '';
                } else {
                    this.getOrgType = !this.getOrgType;
                }
            },
            'queryForm.orgType'(id, oldId) {
                if(id == oldId){
                    return;
                }
                this.queryForm.orgId = '';
            },
        },
      
    data() {
            var checkUser = (rule, value, callback) => {
                if(this.shopIncomeVoucher.userId || this.shopIncomeVoucher.orgId){
                    callback();
                }else{
                    callback(new Error('请选择'));
                }
            };
            return {
                auditshow:false,
                queryForm:{
                     userId: '', //用户ID
                     orgType: '', //组织类型(1店铺,2门店)
                     orgId: '', //组织ID
                     orderId: '', //订单ID
                     money1: '', //消费凭证
                     money2: '', //贡献值
                     money3: '', //消费券额度
                     money4: '', //动券宝额度
                     firstRatio: '', //第一期比例
                     periods: '', //期数
                     lastMoney: '', //最后一期补贴金额
                     isOver: '', //是否结束
                    isHand: '1',
                    startTime: '',
                    endTime: ''
                },
                isAuditshow:false,
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                SHOP_code: SHOP,
                SHOP_search: SHOP_SEARCH,
                getOrgType: false,
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopIncomeVoucherState: 'add',
                shopIncomeVoucherStates: {
                    add: '新建补贴凭证',
                    check: '查看补贴凭证',
                    edit: '修改补贴凭证'
                },
                srcList: [''],
                multipleSelection: [],
                shopIncomeVoucherList: [],
                shopIncomeVoucher: {
                    id: '', //
                    userId: '', //用户ID
                    orgType: 2, //组织类型(1店铺,2门店)
                    orgId: '', //组织ID
                    orderId: '', //订单ID
                    money1: '', //消费凭证
                    money2: '', //贡献值
                    money3: '', //消费券额度
                    money4: '', //动券宝额度
                    firstRatio: 0.015, //第一期比例
                    periods: 0, //期数
                    lastMoney: 0, //最后一期补贴金额
                    isOver: 0, //是否结束
                    money: '',
                    serviceRadio: 0.20,
                    isSend: 1
                },
                btnLoading: false,
                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                rules: {
                    userId: [{ required: true, validator: checkUser, trigger: 'blur' }],
                    orgType: [{ required: true, message: '组织类型(1店铺,2门店)不能为空', trigger: 'blur' }],
                    // orgId: [{ required: true, validator: checkUser, trigger: 'blur' }],
                    orderId: [{ required: true, message: '订单id不能为空', trigger: 'blur' }],
                    money1: [{ required: true, message: '消费凭证不能为空', trigger: 'blur' }],
                    money2: [{ required: true, message: '贡献值不能为空', trigger: 'blur' }],
                    money3: [{ required: true, message: '消费券额度不能为空', trigger: 'blur' }],
                    money4: [{ required: true, message: '动券宝额度不能为空', trigger: 'blur' }],
                    firstRatio: [{ required: true, message: '第一期比例不能为空', trigger: 'blur' }],
                    periods: [{ required: true, message: '期数不能为空', trigger: 'blur' }],
                    lastMoney: [{ required: true, message: '最后一期补贴金额不能为空', trigger: 'blur' }],
                    isOver: [{ required: true, message: '是否结束不能为空', trigger: 'blur' }],
                    money: [{ required: true, message: '消费金额金额不能为空', trigger: 'blur' }],
                    serviceRadio: [{ required: true, message: '服务费类型不能为空', trigger: 'blur' }],
                    isSend: [{ required: true, message: '是否发放不能为空', trigger: 'blur' }]
                },
                showRecordDialog: false,
                serviveTypeList: [],
                timeRange: [],
                countObj: {
                    money1Count: 0,
                    money2Count: 0,
                    money3Count: 0,
                    money4Count: 0,
                    totalMoneyCount: 0
                },
                displayValue:'',
            };
        },
        created() {
            // this.getShopIncomeVoucherList();
            this.getEnum()
            this.getTodayTimeRange()
        },
        methods: {
            // 处理输入事件
            handleInput(value) {
                // 移除所有非数字字符（除了小数点和负号）
                let numStr = value.replace(/[^0-9.-]/g, '')
                
                // 处理多个小数点的情况
                const decimalParts = numStr.split('.')
                if (decimalParts.length > 2) {
                    numStr = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`
                }
                
                // 处理负号不在开头的情况
                if (numStr.includes('-') && !numStr.startsWith('-')) {
                    numStr = numStr.replace(/-/g, '')
                    numStr = '-' + numStr
                }
                
                this.shopIncomeVoucher.money = numStr;
                // 格式化显示值
                this.displayValue = this.formatNumberNew(numStr)
            },
            // 格式化数字为千分位
            formatNumberNew(value) {
                if (value === '' || value === null || value === undefined) return ''
                
                // 转换为字符串并移除所有非数字字符（除了小数点和负号）
                let numStr = String(value).replace(/[^0-9.-]/g, '')
                
                // 处理多个小数点的情况
                const decimalParts = numStr.split('.')
                if (decimalParts.length > 2) {
                    numStr = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`
                }
                
                // 处理负号不在开头的情况
                if (numStr.includes('-') && !numStr.startsWith('-')) {
                    numStr = numStr.replace(/-/g, '')
                    numStr = '-' + numStr
                }
                
                // 分割整数和小数部分
                const parts = numStr.split('.')
                let integerPart = parts[0]
                const decimalPart = parts.length > 1 ? `.${parts[1]}` : ''
                
                // 添加千分位分隔符（跳过负号）
                if (integerPart) {
                    const isNegative = integerPart.startsWith('-')
                    const numWithoutSign = isNegative ? integerPart.slice(1) : integerPart
                    const formatted = numWithoutSign.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    integerPart = isNegative ? `-${formatted}` : formatted
                }

                return  integerPart + decimalPart
            },
            formatNumber(num) {
                // 保证小数部分精度
                let [integer, decimal] = num.toString().split('.');
                
                // 格式化整数部分（千分位）
                integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                
                // 如果有小数部分，则保留小数部分
                return decimal ? `${integer}.${decimal}` : integer;
            },
     
          auditListclick(){
              this.auditshow = true;
            },  
            goodsCloseDialog() {
                this.goodsShowDialog = false;
                this.resetShopIncomeVoucherList();
                this.resetDialog();
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            openRecordDialog(id){
                this.showRecordDialog = true;
                this.$nextTick(() => {
                    this.$refs.record.init(id);
                })
            },
            getEnum(){
                get('/shop/utils/getEnum?enumType=store_service_type').then((res) => {
                    if (res.success && res.code == 200) {
                        
                        this.serviveTypeList = res.enumList;
                    }
                })
            },
            closeRecordDialog(){
                this.showRecordDialog = false;
            },
            beforeImageUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 50;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 50MB!');
                }
                return isLt2M;
            },
            //上传缩略图
            uploadImage(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.shopIncomeVoucher.money1 = res.url;
                    }
                });
            },
            resetShopIncomeVoucherList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopIncomeVoucherList = [];
            },
            // 大图预览
            updateSrcList(src) {
                this.srcList[0] = src
            },
            resetDialog() {
                this.shopIncomeVoucherState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户ID
                      orgType: '', //组织类型(1店铺,2门店)
                      orgId: '', //组织ID
                      orderId: '', //订单ID
                      money1: '', //消费凭证
                      money2: '', //贡献值
                      money3: '', //消费券额度
                      money4: '', //动券宝额度
                      firstRatio: '', //第一期比例
                      periods: '', //期数
                      lastMoney: '', //最后一期补贴金额
                      isOver: '', //是否结束
                      isHand: '',
                    // startTime: '',
                    // endTime: ''
                };
                // this.timeRange = [];
                this.getShopIncomeVoucherList();
            },
            closeDialog() {
                this.showDialog = false
                this.displayValue = ''
                this.shopIncomeVoucher = {
                    id: '', //
                    userId: '', //用户ID
                    orgType: 2, //组织类型(1店铺,2门店)
                    orgId: '', //组织ID
                    orderId: '', //订单ID
                    money1: '', //消费凭证
                    money2: '', //贡献值
                    money3: '', //消费券额度
                    money4: '', //动券宝额度
                    firstRatio: 0.015, //第一期比例
                    periods: 0, //期数
                    lastMoney: 0, //最后一期补贴金额
                    isOver: 0, //是否结束
                    money: '',
                    serviceRadio: 0.20,
                    isSend: 1
                };
            },
            submitForm() {
                if (this.shopIncomeVoucherState == 'add') {
                    this.$refs.shopIncomeVoucherForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/simulated/add`,{ ...this.shopIncomeVoucher }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopIncomeVoucherList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopIncomeVoucherState == 'edit') {
                    this.$refs.shopIncomeVoucherForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/incomevoucher/edit`,{ ...this.shopIncomeVoucher }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopIncomeVoucherList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopIncomeVoucher() {
                this.showDialog = true;
                this.shopIncomeVoucherState = 'add';
            },
            checkShopIncomeVoucher(shopIncomeVoucherId) {
                console.log(shopIncomeVoucherId);
                this.currentShopIncomeVoucherId = shopIncomeVoucherId;

                this.getShopIncomeVoucherById();
                this.showDialog = true;
                this.shopIncomeVoucherState = 'check';
            },
            editShopIncomeVoucher(shopIncomeVoucherId) {
                console.log('shopIncomeVoucher', shopIncomeVoucherId);
                if (shopIncomeVoucherId) {
                    this.currentShopIncomeVoucherId = shopIncomeVoucherId;
                    this.getShopIncomeVoucherById();
                } else {
                    this.shopIncomeVoucher = { ...this.shopIncomeVoucher, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopIncomeVoucherState = 'edit';
            },
            deleteShopIncomeVoucher(shopIncomeVoucherId) {
                let ids = '';
                if (shopIncomeVoucherId) {
                    ids = shopIncomeVoucherId;
                } else {
                    ids = this.multipleSelection.map((shopIncomeVoucher) => shopIncomeVoucher.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/incomevoucher/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopIncomeVoucherList();
                                this.getShopIncomeVoucherList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopIncomeVoucherList() {
                this.resetShopIncomeVoucherList();
                this.getShopIncomeVoucherList();
            },
         // 获取当天开始和结束时间
        getTodayTimeRange() {
            const now = new Date();
            const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
            const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

            const formatDate = (date) => {
                const y = date.getFullYear();
                const m = String(date.getMonth() + 1).padStart(2, '0');
                const d = String(date.getDate()).padStart(2, '0');
                const h = String(date.getHours()).padStart(2, '0');
                const min = String(date.getMinutes()).padStart(2, '0');
                const s = String(date.getSeconds()).padStart(2, '0');
                return `${y}-${m}-${d} ${h}:${min}:${s}`;
            };
            this.queryForm.startTime = formatDate(startOfDay);
            this.queryForm.endTime = formatDate(endOfDay);
            this.timeRange = [formatDate(startOfDay), formatDate(endOfDay)];
        },
            getShopIncomeVoucherList(query = {}) {
                this.loading = true;
                if (this.timeRange) {
                    this.queryForm.startTime = this.timeRange[0];
                    this.queryForm.endTime = this.timeRange[1];
                }else{
                     this.queryForm.startTime = ""
                     this.queryForm.endTime = ""
                }
                get(`/shop/incomevoucher/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopIncomeVoucherList = res.page.list;
                        this.totalNum = res.page.total;
                        if(res.moneyCounts){
                            this.countObj = res.moneyCounts;
                        }else{
                            this.countObj= {
                                money1Count: 0,
                                money2Count: 0,
                                money3Count: 0,
                                money4Count: 0,
                                totalMoneyCount: 0
                            }
                        }
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopIncomeVoucherById() {
                get(`/shop/incomevoucher/get`,{ id: this.currentShopIncomeVoucherId }).then((res) =>{
                    if(res.success){
                      this.getOrgType = true;
                      this.shopIncomeVoucher = { ...this.shopIncomeVoucher, ...res.shopIncomeVoucher };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopIncomeVoucherList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/incomevoucher/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/incomevoucher/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/incomevoucher/importData`,formData);
              this.refreshShopIncomeVoucherList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopIncomeVoucherList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopIncomeVoucherList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.count{
    font-size: 20px;
    margin-left: 10px;
    padding: 0 4px;
    font-weight: 600;
    color: red;
}
.el-btn-group{
    display: flex;
    align-items: center;
}
</style>